<template>
  <div class="order-input">
    <fetch-error
      v-if="data instanceof FetchError"
      @retry="error = null"
      :error="data"
    ></fetch-error>
    <loader v-else-if="data === null"></loader>
    <template v-else>
      <div class="category-grid">
        <div>
          <category v-model="activeCategory" :categories="data" />
        </div>
        <swiper
          class="swiper"
          @slideChange="slideChange"
          :options="swiperOption"
        >
          <swiper-slide v-for="item in data" :key="item.id">
            <products
              v-if="item.id === activeCategory.id"
              :shoppingCard="shoppingCard"
              :activeCategory="item"
              :categories="data || []"
              @select="addProduct($event)"
              @remove="removeProduct($event)"
            ></products>
          </swiper-slide>
        </swiper>
        <div class="shopping-card">
          <shopping-card
            @add="addProduct($event)"
            @remove="removeProduct($event)"
            @create-order="handleShowCreateOrderPopup()"
            :shoppingCardInfo="shoppingCardInfo"
          ></shopping-card>
        </div>
      </div>
      <vs-popup title="ثبت سفارش" :active.sync="showCreateOrderPopup">
        <create-order
          @resetData="resetData"
          @close="showCreateOrderPopup = false"
          :order="order"
          :shoppingCardInfo="shoppingCardInfo"
        >
        </create-order>
      </vs-popup>
    </template>
  </div>
</template>
<script>
import Category from "./InputCategory.vue";
import Products from "./Products.vue";
import ShoppingCard from "./shopping-card/ShoppingCard.vue";
import CreateOrder from "./createOrder/CreateOrder.vue";
import providerApiService from "../../../services/api/ProviderApiService";
import { mapGetters } from "vuex";
import FetchError from "./../../../services/api/FetchError";
import { isMobileView } from "../../../helpers/Functions";

export default {
  name: "Input",
  data() {
    return {
      FetchError,
      data: null,
      activeCategory: null,
      showCreateOrderPopup: false,
      shoppingCard: [],
      swiperOption: {
        allowTouchMove: isMobileView(),
      },
    };
  },
  components: {
    Category,
    Products,
    ShoppingCard,
    CreateOrder,
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
    shoppingCardInfo() {
      const shoppingCardInfo = this.shoppingCard.reduce(
        (accumulator, product) => {
          const findProductIndex = accumulator.findIndex((i) =>
            i.product ? i.product.id === product.id : false
          );

          if (findProductIndex > -1) {
            accumulator[findProductIndex].unit++;
            accumulator[findProductIndex].price +=
              product.price.discountDistinct(product.discount);
          } else {
            accumulator.push({
              product,
              unit: 1,
              price: product.price.discountDistinct(product.discount),
            });
          }

          return accumulator;
        },
        []
      );

      const finalPrice = shoppingCardInfo
        .map((i) => i.price)
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

      const products = shoppingCardInfo.sort(
        (a, b) => a.product.categoryLevel - b.product.categoryLevel
      );

      return {
        products,
        finalPrice,
      };
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
    },
  },
  mounted() {
    if (this.value) {
      this.shoppingCard = this.value.map((item) => {
        return { ...item, categoryLevel: item.level };
      });
    }

    providerApiService
      .menu(this.currentProvider.id)
      .then((res) => {
        this.data = res.data;
        if (res.data[0]) this.activeCategory = res.data[0];
      })
      .catch((err) => {
        this.data = err;
      });
  },
  props: {
    order: {
      type: Object,
    },
    value: {
      type: Array,
    },
  },
  watch: {
    activeCategory(item) {
      const categoryIndex = this.data.findIndex(
        (element) => element.id === item.id
      );

      const swiper = this.getSwiperSelector();

      if (swiper) {
        // Now you can use all slider methods like
        swiper.slideTo(categoryIndex, 0, false);
      }
    },
  },
  methods: {
    resetData() {
      this.activeCategory = this.data[0];
      this.showCreateOrderPopup = false;
      this.shoppingCard = [];
    },
    addProduct(product) {
      if (product.price === 0) {
        this.$vs.notify({
          text: "این محصول فاقد قیمت میباشد و امکان اضافه کردن به سبد خرید را ندارد.",
          color: "warning",
          position: "bottom-center",
        });
        return;
      }

      this.shoppingCard = [
        ...this.shoppingCard,
        {
          ...product,
          categoryLevel: this.activeCategory.level,
          categoryId: this.activeCategory.id,
        },
      ];
    },
    removeProduct(product) {
      this.shoppingCard.splice(
        this.shoppingCard.findIndex((item) => item.id === product.id),
        1
      );
    },
    handleShowCreateOrderPopup() {
      this.showCreateOrderPopup = true;
    },
    slideChange() {
      const swiper = this.getSwiperSelector();

      if (swiper) {
        // Now you can use all slider methods like
        this.activeCategory = this.data[swiper.activeIndex];
      }
    },
    getSwiperSelector() {
      const swiperHtml = document.querySelector(".swiper");

      if (swiperHtml) {
        return swiperHtml.swiper;
      }

      return null;
    },
  },
};
</script>
<style scoped lang="scss">
.category-grid {
  display: flex;
  flex-direction: row;

  @media (max-width: 700px) {
    display: block;
  }

  .swiper {
    flex: 1;
    display: flex;
  }
}

.shopping-card {
  flex: 1;
  display: flex;
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  z-index: 10;

  @media (min-width: 768px) {
    max-width: 60%;
  }

  @media (min-width: 992px) {
    max-width: 50%;
  }

  @media (min-width: 1200px) {
    left: 260px;
    max-width: 50%;
  }

  @media (min-width: 1600px) {
    left: 260px;
    max-width: 40%;
  }

  .vx-card {
    position: sticky;
    bottom: calc(67px + 2.2rem);
  }
}
</style>
